import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavService {
public position: BehaviorSubject<string>;
public position$: Observable<string>;
  constructor() {
    this.position = new BehaviorSubject('top');
    this.position$ = this.position.asObservable();
   }

   public setNavPosition(position: string) {
     this.position.next(position);
   }
}
